exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".term-articles .container{max-width:1040px;margin-top:3.1rem;margin-bottom:5em}.term-articles .icon-wrapper{display:flex;justify-content:center}.term-articles .icon-wrapper .MuiSvgIcon-root{font-size:2rem}.term-articles .term-paragraph{font-size:.875rem;line-height:1rem}.term-articles .term-main{padding-left:10px}.term-articles .article-term{padding-bottom:6px;font-size:30px;font-weight:500}@media(max-width: 575px){.term-articles .article-term{font-size:1.5rem}}.term-articles .section-text{margin:0;text-align:center;font-size:1rem;line-height:1.188rem}.term-articles .term-article{font-size:.875rem;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/LandingPages/Articles/TermArticles.scss
// module id = 7781
// module chunks = 13